export const SAVE_UNLOCK_CLASS = 'hdv-demo-save-unlocked'

export const unlockDemoSaveButton = (button) => {
    if (!button) return
    button.classList.add(SAVE_UNLOCK_CLASS)
}

export const lockDemoSaveButton = (button) => {
    if (!button) return
    button.classList.remove(SAVE_UNLOCK_CLASS)
    delete button._hdvAllowNativeSave
    if (button.style) {
        button.style.pointerEvents = ''
        button.style.opacity = ''
    }
}

export const withNativeDemoSaveAllowed = (button, runClick) => {
    if (!button) {
        if (typeof runClick === 'function') runClick()
        return
    }

    const wasUnlocked = button.classList.contains(SAVE_UNLOCK_CLASS)
    const tourHandler = button._hdvDemoSaveHandler

    if (tourHandler) {
        button.removeEventListener('click', tourHandler, true)
    }

    button.classList.add(SAVE_UNLOCK_CLASS)
    button._hdvAllowNativeSave = true
    button.disabled = false
    button.style.pointerEvents = 'auto'
    button.style.opacity = '1'

    try {
        if (typeof runClick === 'function') runClick()
        else button.click()
    } finally {
        button._hdvAllowNativeSave = false
        if (tourHandler) {
            button.addEventListener('click', tourHandler, true)
        }
        if (!wasUnlocked) {
            button.classList.remove(SAVE_UNLOCK_CLASS)
            button.style.pointerEvents = ''
            button.style.opacity = ''
        }
    }
}

export const findDemoSaveButton = (target) =>
    target?.closest?.('[data-tour$="-salvar"]') || null
